//  获取商品id
async function getCommodityInf (handle) {
  return new Promise((resolve, reject) => {
    (function (yhsd) {
      return yhsd.ready(function (sdk) {
        return sdk
          .product
          .get(handle, function (inf) {
            resolve(inf.res.product)
          })
      })
    })(window.yhsd, handle)
  })
}

export {getCommodityInf}



// WEBPACK FOOTER //
// ./src/api/getCommodityInf.js